import type { Observable as ObservableType } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-fetch';
import type { CreateCardOptions, InlineCreateResponse } from './types';

export function inlineCreateIssue({
	summary,
	issueTypeId,
	contexts,
	overrides,
}: CreateCardOptions): ObservableType<InlineCreateResponse> {
	return fetchJson$('/rest/inline-create/1.0/issue', {
		method: 'POST',
		body: JSON.stringify({
			summary,
			issueTypeId,
			contexts,
			overrides,
		}),
	});
}
